export const load = () => ({
	h1: '6 Simple Ways To Fix Drafty Windows',
	title: '6 Easy Ways to Fix Drafty Windows & Save Money',
	description:
		'Looking for ways to fix drafty windows without replacing them? Here are suggestions to insulate drafty windows, including Indow interior storm window inserts.',
	showTitle: true,
});
